<ng-container
  *ngIf="
    ipBoard.boardPart != null &&
    (boardPartSignExampleStyleLeft != null ||
      boardPartSignExampleStyleRight != null)
  "
>
  <ng-container
    *ngIf="
      boardPartSignExampleStyleLeft != null &&
        boardPartSignExampleStyleRight == null;
      else leftAndRight
    "
  >
    <div class="sign-example-container">
      <ng-container *ngIf="withFrame; else withoutFrame">
        <div
          class="frame"
          [ngClass]="
            recommendedCollaborativeOption
              ? 'recommended-collaborative-option'
              : ''
          "
        >
          <ng-container
            *ngTemplateOutlet="
              singleExample;
              context: {
                example: boardPartSignExampleStyleLeft
              }
            "
          ></ng-container>
        </div>
      </ng-container>
      <ng-template #withoutFrame>
        <ng-container
          *ngTemplateOutlet="
            singleExample;
            context: {
              example: boardPartSignExampleStyleLeft
            }
          "
        ></ng-container>
      </ng-template>
    </div>
  </ng-container>
  <ng-template #leftAndRight>
    <div class="sign-example-container">
      <ng-container *ngIf="withFrame; else dualWithoutFrame">
        <div class="frame">
          <ng-container
            *ngTemplateOutlet="
              dualExample;
              context: {
                leftExample: boardPartSignExampleStyleLeft,
                rightExample: boardPartSignExampleStyleRight
              }
            "
          ></ng-container>
        </div>
      </ng-container>
      <ng-template #dualWithoutFrame>
        <ng-container
          *ngTemplateOutlet="
            dualExample;
            context: {
              leftExample: boardPartSignExampleStyleLeft,
              rightExample: boardPartSignExampleStyleRight
            }
          "
        ></ng-container>
      </ng-template>
    </div>
  </ng-template>
</ng-container>

<ng-template #singleExample let-example="example">
  <div class="sign-example" [ngStyle]="example"></div>
</ng-template>

<ng-template
  #dualExample
  let-leftExample="leftExample"
  let-rightExample="rightExample"
>
  <div class="d-flex">
    <div class="strong">
      <div class="text-container">
        <div>Links bord</div>
      </div>
      <div
        class="smaller-sign-example"
        [ngStyle]="boardPartSignExampleStyleLeft"
      ></div>
    </div>
    <div class="strong small-left-space">
      <div class="text-container">
        <div>Rechts bord</div>
      </div>
      <div
        class="smaller-sign-example"
        [ngStyle]="boardPartSignExampleStyleRight"
      ></div>
    </div>
  </div>
</ng-template>
